module.exports = __webpack_public_path__ + "img/img27.3e1dab4e.png";